export default {"src":"/_next/static/media/ancap-logo.f22f6737.svg","height":55,"width":190,"blurWidth":0,"blurHeight":0};